import {
  OrderByIdViewQuery,
  OrderByIdViewQuery$data,
  OrderByIdViewQueryNode,
} from '@bts-web/data-layer/server';
import { gqlNetworkFetch } from '@bts-web/utils-relay';

export type GetOrderByIdResult =
  | { data: NonNullable<OrderByIdViewQuery$data['order']> }
  | { errors: string[] };

export const getOrderById = async (id: string): Promise<GetOrderByIdResult> => {
  const response = await gqlNetworkFetch<OrderByIdViewQuery>(
    OrderByIdViewQueryNode.params,
    { id },
  );

  if (response.errors || !response.data?.order) {
    return {
      errors: response.errors?.length ? response.errors : ['Order not found'],
    };
  }

  return { data: response.data.order };
};
